// ── Pages personnalisées d'une boutique ───────────────────────────────
// Le marchand crée des pages libres (titre, slug, contenu HTML avec les
// balises du site public). Il peut soit les PUBLIER sur son site, soit
// simplement les PARTAGER via un lien direct (/p/slug).

export interface MerchantCustomPage {
  id: number;
  idcommerce: number;
  ownerId: number | null;
  title: string;
  slug: string;
  content: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MerchantCustomPageInput {
  title: string;
  slug: string;
  content: string;
  published: boolean;
}

/** Transforme un titre en slug d'URL lisible (sans accents ni espaces). */
export function slugify(input: string): string {
  return (input || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

export function mapCustomPageRow(row: Record<string, unknown>): MerchantCustomPage {
  return {
    id: Number(row.id),
    idcommerce: Number(row.idcommerce),
    ownerId: row.owner_id != null ? Number(row.owner_id) : null,
    title: (row.title as string) || '',
    slug: (row.slug as string) || '',
    content: (row.content as string) || '',
    published: Boolean(row.published),
    createdAt: (row.created_at as string) || '',
    updatedAt: (row.updated_at as string) || '',
  };
}